<template>

    <div class="layout__container">

        <h3 class="text__align-center text__colour-teal">Direct Mail Spend</h3>

        <div class="layout__position-center">
            <div class="layout__position-left layout__width-100">
                <DirectMailSpendSearch v-bind:searchParams="searchParams" v-bind:sales="sales"></DirectMailSpendSearch>
            </div>

            <div class="insights-table layout__width-100 layout__position-left">
                <el-table class="el-table__09vh" :data="sales" width="100%" height="620px" show-summary :summary-method="getSummaries" @sort-change="handleSortOrderChange" 
                v-loading.fullscreen.lock="loading" element-loading-text="Loading..." element-loading-background="rgba(79, 147, 168, 0.2)" empty-text="No data has been returned for the selected dates">
                    <el-table-column prop="territory" label="Territory" class-name="layout__width-10 el-table-column__no-pointer" sortable="custom">
                    </el-table-column>
                    <el-table-column prop="customer" label="Customer" class-name="layout__width-10 el-table-column__no-pointer" sortable="custom">
                    </el-table-column>
                    <el-table-column prop="total" label="Total" class-name="layout__width-5 el-table-column__no-pointer" sortable="custom" :formatter="getCurrencyAmount">
                    </el-table-column>
                    <el-table-column class-name="layout__width-10 el-table-column__no-pointer" width="100px">
                        <template slot-scope="scope">
                            <el-button class="button-teal button__download" size="mini" :loading="loadings[scope.$index]" v-on:click="csv(scope.$index, scope.row)">Download
                            </el-button>
                        </template>
                    </el-table-column>
                </el-table>
            </div>
        </div>

    </div>

</template>

<script>

    import moment from 'moment';
    import Axios from 'axios';
    import download from 'downloadjs';
    import DirectMailSpendSearch from '@/components/insights/DirectMailSpendSearch';
    import {axios} from '@/mixins/Axios.js';
    import {csvDownloadHelper} from '@/mixins/CsvDownloadHelper.js';
    import {dataFormatter} from '@/mixins/DataFormatter.js';
    import {sortJsonArrayHelper} from '@/mixins/sort-json-array.js';
 
    export default {
        name: "sales",
        mixins: [axios, csvDownloadHelper, dataFormatter, sortJsonArrayHelper],
        components: {
            DirectMailSpendSearch
        },
        props: {
            view: ''
        },
        data() {
            return {
                selectedStartDate: '',
                selectedEndDate: '',
                selectedTerritory: '',
                selectedCustomer: '',
                sales: [],
                loading: false,
                loadings: {},
                serviceRouteUrl: `${process.env.VUE_APP_INSIGHTSAPIHOST}`,
                exportDate: new Date().toLocaleDateString('en-GB') + '_sales.csv',
                searchParams: {
                    salesDateRange: [new Date().toLocaleDateString('en-GB'), new Date().toLocaleDateString('en-GB')],
                },
            }
        },
        created() {
            this.isUserAuthorised();
        },
        methods: {
            getCurrencyAmount(row, column, cellValue) {
                if (typeof cellValue === 'undefined') {
                    return '£0'
                } else {
                    return '£' + cellValue.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
                }
            },
            handleSortOrderChange(sortProps) {
                console.log('prop: ' + sortProps.prop);
                console.log('order: ' + sortProps.order);

                this.sortJsonArray(this.sales, sortProps.prop, sortProps.order.slice(0, 3));
            },
            getSummaries(param) {
                const { columns, data } = param;
                const sums = [];
                columns.forEach((column, index) => {
                    var noTotalCols = ["Month", "Year"];
                    if (noTotalCols.indexOf(column.label) >= 0) {
                        sums[index] = '';
                        return;
                    }
                    const values = data.map(item => Number(item[column.property]));
                    if (!values.every(value => isNaN(value))) {
                        sums[index] = '£' + this.returnWithCommas(values.reduce((prev, curr) => {
                            const value = Number(curr);
                            if (!isNaN(value)) {
                                return prev + curr;
                            } else {
                                return prev;
                            }
                        }, 0).toFixed(2).toString());
                    } else {
                        sums[index] = '';
                    }
                });

                return sums;
            },
            csv(index, row) {
                this.selectedStartDate = new Date(row.year, row.month - 1, 1);
                this.selectedEndDate = new Date(row.year, row.month, 0);
                this.selectedTerritory = encodeURIComponent(row.territory);
                this.selectedCustomer = encodeURIComponent(row.customer);

                console.log('this.selectedStartDate:' + this.selectedStartDate);
                console.log('this.selectedEndDate:' + this.selectedEndDate);
                console.log('this.selectedTerritory:' + this.selectedTerritory);
                console.log('this.selectedCustomer:' + this.selectedCustomer);

                console.log('before')
                console.log(this.searchParams)

                let searchTerms = Object.assign({}, this.searchParams)
                console.log('searchTerms')
                console.log(searchTerms)

                console.log('after search is copied')
                console.log(this.searchParams)

                console.log('after search is copied - new object')
                console.log(searchTerms)

                var startDateArray = searchTerms.salesDateRange[0].split("/"),
                    startDate = moment(new Date(startDateArray[1], startDateArray[0] - 1, 1)).format('YYYY%2FMM%2FDD'),
                    endDateArray = searchTerms.salesDateRange[1].split("/"),
                    endDate = moment(new Date(endDateArray[1], endDateArray[0], 0)).format('YYYY%2FMM%2FDD'),
                    endpoint = this.serviceRouteUrl + '/api/v1/insights/order/GetDirectMailSpendDetails?startDate=' + startDate + '&endDate=' + endDate + '&territory=' + this.selectedTerritory + '&customer=' + this.selectedCustomer;

                console.log(endpoint)

                this.$set(this.loadings, index, false);

                Axios.get(endpoint, this.returnHeaderUsingToken())
                .then(response => {
                    const fields = [
                        {label: 'Order Id', value: 'order_Id'},
                        {label: 'Source Id', value: 'source_Id'},
                        {label: 'Job Id', value: 'job_Id'},
                        {label: 'Category', value: 'category'},
                        {label: 'Brand', value: 'brand'},
                        {label: 'Price Code', value: 'price_Code'},
                        {label: 'Product', value: 'product'},
                        {label: 'Stock', value: 'stock'},
                        {label: 'Finishing', value: 'finishing'},
                        {label: 'Product Category', value: 'product_Category'},
                        {label: 'Product Description', value: 'product_Description'},
                        {label: 'Territory', value: 'territory'},
                        {label: 'Status', value: 'status'},
                        {label: 'Branch', value: 'branch'},
                        {label: 'Name', value: 'name'},
                        {label: 'Job Name', value: 'job_Name'},
                        {label: 'Quantity', value: 'quantity'},
                        {label: 'Value', value: 'value'},
                        {label: 'Billing Status', value: 'billing_Status'},
                    ];

                    this.downloadCsv(this.exportDate, fields, response.data.directMailSpendDetails)

                    this.$nextTick(() => { // Loading should be closed asynchronously
                        this.$set(this.loadings, index, false);
                    });
                })
                .catch(error => {
                    if (error.response) {
                        this.$message.error('Sorry there has been an issue retrieving the information you requested.');
                    }

                    this.$nextTick(() => { // Loading should be closed asynchronously
                        this.$set(this.loadings, index, false);
                    });
                })
            }
        }
    };
</script>